import axios from "axios";
import React, {
    Component,
    useState,
    useEffect,
    useContext,
    lazy,
    Suspense,
} from "react";
import { Helmet } from "react-helmet";
import BitmediaAd from '../../../mission/bitmedia';
import AdSense from "react-adsense";
import { FaRegClock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../../../AppContext";
import { Cookies } from "../../../../index.js";
import Login_google from './.././../login';
import Buylink from './../../urlshorten_system/buy_link.jsx';
function Mode_partner() {
    const [nutxuly, setnutxuly] = useState("");
    const [disabledbutton, setdisabledbutton] = useState(true);
    const [buttonTextjop, setbuttonTextjop] = useState("");
    const [loading, setLoading] = useState(false);
    const [apikey, setapikey] = useState(false);
    const [hustmediavipro, sethustmediavipro] = useState("");
    function laydulieu() {
        const myCookieValue = Cookies.get("apikey");
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get("hustmediavipro");
        if (myCookieValue) {
            setapikey(myCookieValue);
        }
        if (hustmediavipro) {
            sethustmediavipro(hustmediavipro);
        }
        axios
            .get("https://hust.media/link/load_mode/mode_partner_ads.php", {
                params: {
                    lienket: hustmediavipro,
                    apikey: myCookieValue,
                    code_item: code_item
                },
            })
            .then((response) => {
                testFunction(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    }
    function testFunction(response) {
        setLoading(true);
        const info = response.data;
        const status = info.status;
        const message = info.message;
        const service_name = info.service_name;
        if (status == 0) {
            alert_error(message);
        }
        else if (status == 1) {
            alert_success(message);
        }
        if (service_name) {
            setbuttonTextjop(service_name);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }

    };
    useEffect(() => {
        laydulieu();
    }, []);
    return (
        <div>
            <div className="form-control">
                <div
                    style={{ textAlign: "center" }}
                    className="mt-0 justify-center items-center">
                    {/* {apikey ? (<><Buylink hustmediavipro={hustmediavipro} /></>) : (<>
                        <div className="mb-1 ">
                            <div>Đăng nhập google để nhận link miễn phí</div>
                            <Login_google />
                        </div>
                        <div className="mb-1 ">Hoặc:</div>
                    </>)} */}
                    {loading == false ? (
                        <>
                            <div>
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                ></div>
                                <span>Đang tải dữ liệu</span>
                            </div>
                        </>
                    ) : (
                        loading == true && (
                            <>
                                <div className="mt-2 mx-auto max-w-md text-center">
                                    <div className="text-pink-500 text-center text-xl font-bold">Please wait a moment 😊</div>
                                </div>
                            </>
                        )
                    )}
                </div>
            </div>
        </div>
    );
}

export default Mode_partner;